import React, { FC } from 'react';

import { Button } from 'Modules/ui';
import { useAction } from 'Modules/core/redux';
import { WithT } from 'Modules/core/i18n';

import { certificatesActions } from '../../state/certificates/actions';


type UpdateCertsButtonProps = WithT & {
    path: 'sign' | 'addToProfile';
    disabled: boolean;
}

export const UpdateCertsButton: FC<UpdateCertsButtonProps> = ({ path, t, disabled }) => {
    const update = useAction(
        () => certificatesActions.updateList(path, {}),
        [path],
    );
    return (
        <Button
            variant='secondary'
            disabled={disabled}
            onClick={update}
        >
            {t('refresh')}
        </Button>
    );
};
